import {
    SELECT_ORGANIZATION_RECEIVE,
    SELECT_ORGANIZATION_ERROR
} from '../bevegoConstants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    selectedOrganization: {},
    selectedAddress: '',
    organizations: [],
    addressList: [],
    errors: {},
    isEdiLogin: false
};

export const selectOrganization = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SELECT_ORGANIZATION_RECEIVE:
            return {
                ...state,
                ...payload
            };
        case SELECT_ORGANIZATION_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };            
        default:
            return state;
    }
};
